<template>
  <div class="help-icon">
    <svg
      @click.prevent="clickedHelp"
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 0 24 24"
      width="24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
      />
    </svg>
    <div v-if="showHelpText" ref="helpText" class="help-text">
      {{ helpText }}
    </div>
  </div>
</template>

<script>
/**
 * Help icon which displays help text when passed a prop.
 *
 * TODO:
 *    - Reduce reliance on parent component.
 *          Right now, parent component still must handle the actual toggling of the text.
 *
 *          This is because when the text is clicked, we need to set an event handler on the
 *          parent component, so we can tell when the background is clicked (meaning the help
 *          text should go away).
 *
 **/

export default {
  name: 'HelpIcon',
  components: {},
  props: {
    showHelpText: {
      type: Boolean,
      default: false,
    },
    helpText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {}
  },
  methods: {
    clickedHelp() {
      this.$emit('click')
    },
  },
  computed: {},
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
.help-icon {
  margin-left: 0.5rem;
  display: flex;
  flex-flow: row;
  align-items: center;
  padding-top: 1rem;
  margin-top: 0.25rem;
  cursor: pointer;
}
svg {
  fill: var(--dark-brand-color);
}
.help-text {
  position: absolute;
  font-size: 1rem;
  font-weight: 300;
  border-radius: 0.4rem;
  max-width: 12rem;
  padding: 1rem 0.8rem;
  box-shadow: 0 4px 8px 0 $mid-gray;
  background-color: $white;
  margin-left: -8rem;
  margin-top: 7rem;
  z-index: 101;

  /* prevent selection of text */
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */
}
</style>
